import { type PaginationSortDirection } from '~/constants';

import {
  REPROCESSING_INVOICE_STATUS,
  type ReprocessingInvoiceOrderBy,
  type ReprocessingInvoicesFilters,
} from '~/data/invoice-reprocessing';

export type PredefinedView =
  | {
      displayOptions: {
        columnModel?: string[]; // TODO: infer the field names from the columns definition
        displayAs: 'table';
      };
      filterModel: Record<
        ReprocessingInvoicesFilters,
        string | string[] | undefined
      >;
      id: string;
      label: string;
      sortModel?: {
        orderBy: ReprocessingInvoiceOrderBy;
        sortDirection: PaginationSortDirection;
      };
    }
  | {
      displayOptions: { displayAs: 'cards' | 'chart' };
      filterModel: Record<
        ReprocessingInvoicesFilters,
        string | string[] | undefined
      >;
      id: string;
      label: string;
      sortModel?: {
        orderBy: ReprocessingInvoiceOrderBy;
        sortDirection: PaginationSortDirection;
      };
    };

/**
 * Definition of views to filter, sort, and display information about problems in the invoice processing pipeline.
 */
export const PREDEFINED_VIEWS: PredefinedView[] = [
  {
    displayOptions: { displayAs: 'table' },
    filterModel: {
      channel: ['api', 'email'],
      createdAfter: '',
      createdBefore: '',
      dryRun: undefined,
      needsAiParsing: undefined,
      searchString: '',
      status: REPROCESSING_INVOICE_STATUS.filter(
        (status) => status.includes('error') || status === 'handoff_failed',
      ),
    },
    id: 'allErrorsLive',
    label: 'Alle Fehler - Live',
  },
  {
    displayOptions: { displayAs: 'table' },
    filterModel: {
      channel: ['admin_upload'],
      createdAfter: '',
      createdBefore: '',
      dryRun: undefined,
      needsAiParsing: undefined,
      searchString: '',
      status: REPROCESSING_INVOICE_STATUS.filter(
        (status) => status.includes('error') || status === 'handoff_failed',
      ),
    },
    id: 'allErrorsAdminUpload',
    label: 'Alle Fehler - Admin Upload',
  },
  {
    displayOptions: { displayAs: 'table' },
    filterModel: { status: ['invoice_process_stopper_error'] },
    id: 'invoiceProcessStoppers',
    label: 'Gestoppt',
  },
  // {
  //   id: 'invoiceProcessStoppers',
  //   label: 'Gestoppt',
  //   filterModel: {
  //     channel: ['admin_upload'],
  //     createdAfter: '',
  //     createdBefore: '',
  //     dryRun: false,
  //     needsAiParsing: false,
  //     searchString: '',
  //     status: ['ambiguous_files_error'],
  //   },
  //   sortModel: {
  //     orderBy: 'process_finished_on',
  //     sortDirection: 'ASC',
  //   },
  //   displayOptions: {
  //     columnModel: ['status', 'comment'], // demonstration of customization of columns
  //     displayAs: 'table',
  //   },
  // },
  // {
  //   id: 'test2',
  //   label: 'Problem-Filter 2 TBD',
  //   filterModel: {
  //     channel: [],
  //     createdAfter: '',
  //     createdBefore: '',
  //     dryRun: false,
  //     needsAiParsing: false,
  //     searchString: '',
  //     status: ['done'],
  //   },
  //   displayOptions: {
  //     columnModel: ['comment', 'status'], // demonstration of customization of columns + ordering
  //     displayAs: 'table',
  //   },
  // },
] as const;
